var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterbtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 88,
    viewBox: "0 0 84 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10_14)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 9.5,
    stroke: "black"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 64,
    height: 64,
    fill: "url(#pattern0_10_14)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10_14",
    x: 0,
    y: 0,
    width: 84,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10_14"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10_14",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_10_14",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_10_14",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_10_14",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterbtn);
export default __webpack_public_path__ + "static/media/twitterbtn.70c62d4bcfba19b209540f13b410f255.svg";
export { ForwardRef as ReactComponent };